import {UserProvider} from './context/user'

import PortalRouter from './components/portal/PortalRouter'
import OnboardingRouter from './components/onboarding/OnboardingRouter'
import {useAuth} from 'features/common/context/auth'

const AuthorizedView = () => {
    const {user} = useAuth()
    if (!user) {
        return null
    }

    if (!user.onboarding.completed) {
        return (
            <UserProvider>
                <OnboardingRouter />
            </UserProvider>
        )
    }

    return (
        <UserProvider>
            <PortalRouter />
        </UserProvider>
    )
}

export default AuthorizedView
